const pattern = /^(s-|S-){0,1}[0-9]{3}\s?[0-9]{2}$/;
export default function (value) {
    return pattern.test(value);
}